import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { AbstractControl, AbstractControlDirective, FormBuilder, FormControl, Validators } from "@angular/forms";
import { Subscription, timer } from "rxjs";
import { ExtraModel, LoginTabConfigurationInterface, recoverEmiter } from "./models";
import { cValidators } from "../../../models/validator";
import { AuthService, InlineResponse200 } from "../../../api";
import { EnvironmentService } from "../../../api/api/environment.service";
import { PersonalizationsService } from "../../../base/services/personalizations/personalizations.service";
import { Environment } from "../../../models/environment";
import { HttpErrorResponse } from "@angular/common/http";
import { LoadingService } from "../../loading/loading.service";

@Component({
    selector: 'iv-login',
    templateUrl: './iv-login.component.html',
    styleUrls: ['./iv-login.component.scss'],
    providers: [AuthService, EnvironmentService]
  })

  export class IvLoginComponent implements OnInit, OnDestroy {
    @Input() errorMessages = {
        'required': 'El campo es requerido',
        'pattern': 'Solo se permite determinados carácteres.',
        'email': 'El correo electrónico introducido no es válido.',
        'password': 'La contraseña no es correcta.'
    };

    hide: boolean = true;
    @Input() srcLogoGeneral: string = "assets/images/logo-ivnosys.png";
    @Input() accordionTabs: LoginTabConfigurationInterface[];
    @Input() classAccordion: string = "";
    @Input() extras: ExtraModel[];
    @Input() saludo: string = "";
    @Input() loading: boolean = false;
    @Output() ComeBack = new EventEmitter();
    @Input() messages: string[] = ['¡Buenos días!', '¡Buenas tardes!', '¡Buenas noches!'];
    @Input() logo: string = "assets/images/logo-ivnosys.png";
    @Input() loadingText: string = "Iniciando...";
    @Input() autocomplete: boolean = true;
    @Input() color: string;
    @Input() textColor: string;
    @Input() disableLocalStorage: boolean = false;
    @Input() displayPromo: boolean = true;
    @Input() promotional: string[] = [];
    @Input() viewSAML: boolean;
    @Input() onlyViewSAML: boolean;

    @Output() onBeforeSubmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() onRecoverPass: EventEmitter<recoverEmiter> = new EventEmitter<recoverEmiter>();
    @Output() onRedirectSAML: EventEmitter<void> = new EventEmitter<void>();

    iexplorer: boolean = true;
    primeravezIE: number = 0;
    private control: AbstractControlDirective | AbstractControl;
    timer: Subscription;
    headMessage: string;
    btnDisabled: boolean = false;
    btnSAML: boolean = false;
    btnOnlySAML: boolean = false;

    environment: Environment;

    constructor(
        private readonly apiService: AuthService,
        private readonly personalization: PersonalizationsService,
        private readonly fb: FormBuilder,
        private _loading: LoadingService,
    ) {
        this.environment = this.personalization.sendEnv;
    }

    ngOnInit() {
        this.iexplorer = window.navigator.userAgent.indexOf("Trident/7.0") >= 0;
        this.setTimer();

        for (let i = 0; i < this.accordionTabs.length; i++) {
            if (this.accordionTabs[i].validators === undefined) {
                this.accordionTabs[i].validators = this.fb.group({});
            }
            let f = this.accordionTabs[i].fields;

            for (let a = 0; a < f.length; a++) {
                if (this.accordionTabs[i].validators.controls[f[a].id] === undefined) {
                    this.accordionTabs[i].validators.addControl(f[a].id, new FormControl('', Validators.compose(f[a].validate === undefined ? [cValidators.required] : f[a].validate)));
                }
            }
        }
        this.btnSAML = this.viewSAML ? true : false;
        this.btnOnlySAML = this.onlyViewSAML ? true : false;
    }

    getErrorMessage(key: string, index: number): string[] | false {
        this.control = this.accordionTabs[index].validators.controls[key];
        return this.control.errors ? Object.keys(this.control.errors).map(field => this.errorMessages[field]) : false;
    }


    private savelocalStorage(arrayResponse: any, Ivsign: boolean = false): void {
        document.cookie = 'access_token=' + arrayResponse["access_token"] + ';path=/;';
        for (let key in arrayResponse) {
            if (arrayResponse.hasOwnProperty(key)) {
                if (key == "user") arrayResponse[key] = JSON.stringify(arrayResponse[key]);
                else if (key == ".issued") arrayResponse[key] = new Date().toString();
                else if (key == ".expires") {
                    let date = Ivsign ? new Date().getTime() + 720000 : new Date(arrayResponse[key]).getTime()
                    arrayResponse[key] = new Date(date).toString();
                }
                localStorage.setItem(key, arrayResponse[key]);
            }
        }
    }

    onEnter(event: KeyboardEvent, tab: LoginTabConfigurationInterface, i: number): void {
        event.preventDefault();
        if (tab.validators.valid && !this.btnDisabled) {
            this.onSubmit(i);
        }
    }

    onSubmit(tabIndex: number): void {
        this.loading = this.btnDisabled = true;
        let currentTab = this.accordionTabs[tabIndex];
        let tabValues = currentTab.validators.value;
        this.onBeforeSubmit.emit(tabValues);
        const api = this.apiService;
        const appId = this.environment.appid;

        if(currentTab?.onCustomSubmit) {
            currentTab.onCustomSubmit(tabValues);
            return;
        }

        api.tokenPost("password", tabValues.username, tabValues.password, appId).toPromise().then(
            response => this.response(response),
            (error: HttpErrorResponse) => {
                this.error(error)
            }
        );
    }

    response(response: InlineResponse200): void {
        this.loading = false;
        if (!this.disableLocalStorage) {
            this.savelocalStorage(response);
        }
        this.ComeBack.emit(response);
    }

    error(error: HttpErrorResponse): void {
        this.loading = this.btnDisabled = false;
        this.ComeBack.emit(error);
    }

    setTimer(): void {
        this.timer = timer(300, 60000).subscribe(t => {
            let h = new Date().getHours();
            if (h > 6 && h < 13) this.headMessage = this.messages[0];
            else if (h > 12 && h < 20) this.headMessage = this.messages[1];
            else this.headMessage = this.messages[2];
        });
    }

    recoverPass(index: number): void {
        let t = this.accordionTabs[index];
        let f = t.validators.value;
        const result: recoverEmiter = {
            value: true,
            data: f
        };
        this.onRecoverPass.emit(result);
    }

    onClose(): void {
        this.displayPromo = false;
        localStorage.setItem('promoLogin', 'hide');
    }

    redirectSAML(): void {
        this.btnDisabled = true;
        this._loading.set(true);
        this.onRedirectSAML.emit();
    }

    ngOnDestroy(): void {
        this.timer.unsubscribe();
    }
  }
